import { getImageUrl } from './getImageUrl'

export const getNetworkImage = (network: string) => getImageUrl('networks', network)
